import { IntegrationRecord } from '../types';

import { integrationFragment } from './fragments';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const integrationsQueryAtom = createQueryAtomFactory(
  'automations.integrations',
  () => ({
    integrations: integrationFragment,
  }),
  {
    select: ({ integrations }): IntegrationRecord[] => {
      type IntegrationGraphQLResult = {
        key: string;
        name: string;
        type: string;
        icon: string;
        category: string;
        operations: Array<{
          key: string;
          name: string;
          description: string;
          inputSchema: Record<string, unknown>;
        }>;
      };

      type OperationGraphQLResult = {
        key: string;
        name: string;
        description: string;
        inputSchema?: Record<string, unknown> | null;
      };

      return integrations.map((integration: IntegrationGraphQLResult) => ({
        id: integration.key,
        key: integration.key,
        name: integration.name,
        description: '',
        type: integration.type,
        icon: integration.icon ?? 'box',
        category: integration.category ?? 'general',
        nodeType: 'Action' as const,
        operations: (integration.operations ?? []).map(
          (op: OperationGraphQLResult) => ({
            key: op.key,
            name: op.name,
            description: op.description,
            inputSchema: op.inputSchema ?? {},
          }),
        ),
      }));
    },
  },
);
